import React from "react";
import LightBox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";

export default class ImageList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lightBox: null,
    };
  }

  showLightBox = (startIndex) => {
    this.setState({
      lightBox: { startIndex },
    });
  };

  hideLightBox = () => {
    this.setState({
      lightBox: null,
    });
  };

  getImageList = () => {
    return this.props.images.map((imgData, index) => ({
      url: imgData,
      title: `${this.props.label} (${index + 1})`,
    }));
  };

  render() {
    const imageList = this.getImageList();
    const images = imageList.length > 1 ? imageList : undefined;
    const imageInfo = imageList.length === 1 ? imageList[0].url : undefined;
    const title = imageList.length === 1 ? imageList[0].title : undefined;
    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          overflowX: "auto",
          flex: 1,
          alignItems: imageList?.length ? "flex-start" : "center",
        }}
      >
        {imageList.length ? (
          imageList?.map((image, index) => (
            <img
              src={image.url}
              alt={image.title}
              key={image.title}
              style={{ margin: 4 }}
              width="220"
              height="260"
              onClick={() => this.showLightBox(index)}
            />
          ))
        ) : (
          <div style={{ opacity: 0.5, flex: 1, textAlign: "center" }}>
            Not Available
          </div>
        )}
        {this.state.lightBox ? (
          <LightBox
            images={images}
            image={imageInfo}
            title={title}
            startIndex={this.state.lightBox.startIndex}
            onClose={this.hideLightBox}
          />
        ) : null}
      </div>
    );
  }
}
